<div class="auth-modal">
    <div class="auth-modal__header">
        <h3>{{ registered ? 'Account created' : (isLogin ? 'Login' : 'Sign up') }}</h3>
        <button type="button" class="auth-modal__close" (click)="activeModal.dismiss()" aria-label="Close">&times;</button>
    </div>

    @if (registered) {
        <div class="auth-modal__success">
            <p class="message">Your account has been created and an email has sent to your email address. In order to activate your account click the activation link in the email within 48 hours.</p>
            <button type="button" class="auth-modal__submit" (click)="activeModal.close()">Got it</button>
        </div>
    } @else {
    <form class="auth-modal__body" (ngSubmit)="submit()">
        @if (isLogin) {
            <label class="field">
                <span>Username</span>
                <input ngbAutofocus type="text" name="username" [(ngModel)]="username" (ngModelChange)="errorMessage = ''" autocomplete="username" required />
            </label>
        } @else {
            <label class="field">
                <span>Email</span>
                <input ngbAutofocus type="email" name="email" [(ngModel)]="email" (ngModelChange)="errorMessage = ''" autocomplete="email" required />
            </label>
        }

        <label class="field">
            <span>Password</span>
            <input type="password" name="password" [(ngModel)]="password" (ngModelChange)="errorMessage = ''" autocomplete="current-password" required />
        </label>

        @if (!isLogin) {
            <label class="field">
                <span>Activation code</span>
                <input type="text" name="activationCode" [(ngModel)]="activationCode" required />
            </label>
        }

        @if (errorMessage) {
            <p class="auth-modal__error">{{ errorMessage }}</p>
        }

        <button type="submit" class="auth-modal__submit" [disabled]="submitting">
            {{ isLogin ? 'Login' : 'Sign up' }}
        </button>
    </form>

    <div class="auth-modal__footer">
        @if (isLogin) {
            <span>Don't have an account? <a (click)="switchMode()">Sign up</a></span>
        } @else {
            <span>Already have an account? <a (click)="switchMode()">Login</a></span>
        }
    </div>
    }
</div>
